import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectIsShowcaseMultiScreen } from '@store/actionSlices/multiScreen'
import { RootStateTypeExtra } from '@store/types'

import { useLazyGetMasterKeyQuery } from '@api/master-key'

const useResolveMasterKeyRoom = () => {
  const currentMasterKey = useSelector(
    (state: RootStateTypeExtra) => state.projectIdentity.masterKey
  )
  const { _id: userId } = useSelector(
    (state: RootStateTypeExtra) => state.token
  )
  const isShowcaseMultiScreen = useSelector(selectIsShowcaseMultiScreen)
  const [getMasterKey] = useLazyGetMasterKeyQuery()

  const resolveMasterKeyRoom = useCallback(
    async (
      projectName: string,
      options?: {
        masterKey?: string
        userId?: string
        accessToken?: string
      }
    ): Promise<string | undefined> => {
      const activeMasterKey = options?.masterKey || currentMasterKey
      const activeUserId = options?.userId || userId
      const activeAccessToken = options?.accessToken

      const shouldCheckMultiScreen = !options?.masterKey

      if (
        activeMasterKey &&
        activeUserId &&
        (!shouldCheckMultiScreen || isShowcaseMultiScreen)
      ) {
        try {
          const masterKeyResponse = await getMasterKey({
            masterKey: activeMasterKey,
            userId: activeUserId,
            ...(activeAccessToken && { accessToken: activeAccessToken }),
          }).unwrap()
          const masterKeyData = masterKeyResponse.data

          if (masterKeyData && masterKeyData.isParent) {
            const masterKeyRoom =
              masterKeyData.sessionKeys?.find(
                (sk) => sk.projectId === projectName
              )?.room || ''

            if (masterKeyRoom) {
              return masterKeyRoom
            }
          }
        } catch (e) {
          console.error('Error fetching master key room:', e)
        }
      }

      return undefined
    },
    [currentMasterKey, userId, isShowcaseMultiScreen, getMasterKey]
  )

  return resolveMasterKeyRoom
}

export default useResolveMasterKeyRoom
